// mobile-nav.js
document.addEventListener('DOMContentLoaded', function() {
  window.toggleCollectionBanner = function() {
    const categoryBannerSection = document.getElementById('category-banner-section');
    if (categoryBannerSection.style.display === 'none') {
      categoryBannerSection.style.display = 'block';
    } else {
      categoryBannerSection.style.display = 'none';
    }
  }
});
